import VideoTeam from 'app/components/tv/models/VideoTeam';
import Competition from 'app/components/tv/models/competition';
import Round from 'app/components/tv/models/round';
import {MatchFlag, MatchFlags} from 'app/types/match/MatchFlags';
import {Iso8601DateString} from 'app/types/Iso8601DateString';
import {MatchSection} from 'app/types/match/MatchSection';
import VideoMatchInterface from 'app/components/tv/models/VideoMatchInterface';
import MatchModel from 'app/models/match/MatchModel';

export default class Match {
  readonly id: number;
  readonly slug: string;
  readonly homeTeam: VideoTeam;
  readonly awayTeam: VideoTeam;
  readonly kickoff: Iso8601DateString;
  readonly homeGoal: number | null;
  readonly awayGoal: number | null;
  readonly flags: MatchFlags;
  readonly tickerType: string | null;
  readonly section: MatchSection;
  readonly round: Round;
  readonly competition: Competition;
  readonly spectators: number | null;
  readonly updatedAt: number;
  readonly streamUpdatedAt: number;
  readonly refereeAlias: string | null;
  readonly tickerReservableUntil: Iso8601DateString | null;
  readonly matchModel: MatchModel;

  constructor(data: VideoMatchInterface) {
    Object.assign(this, data);
    this.competition = new Competition(data.competition);
    this.round = new Round(data.round);
    this.homeTeam = new VideoTeam(data.homeTeam);
    this.awayTeam = new VideoTeam(data.awayTeam);
    this.matchModel = new MatchModel(data);
  }

  getMatchString(): string {
    const homeTeamName = this.homeTeam ? this.homeTeam.getTeamName() : 'Unbekanntes Team';
    const awayTeamName = this.awayTeam ? this.awayTeam.getTeamName() : 'Unbekanntes Team';

    return `${homeTeamName} vs. ${awayTeamName}`;
  }

  getCompetitionName(): string {
    return this.competition.getName();
  }

  getMatchDay(): string {
    return this.round.format();
  }

  isFuPaTv(): boolean {
    return this.flags?.includes(MatchFlag.FuPaTv) ?? false;
  }

  getLink(): string {
    return this.matchModel.getLink();
  }
}
